/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  TestDetectionRuleRequestBody,
  TestDetectionRuleRequestBody$Outbound,
  TestDetectionRuleRequestBody$outboundSchema,
} from "../components/testdetectionrulerequestbody.js";

export type TestDetectionRuleSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type TestDetectionRuleSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type TestDetectionRuleSecurity = {
  option1?: TestDetectionRuleSecurityOption1 | undefined;
  option2?: TestDetectionRuleSecurityOption2 | undefined;
};

export type TestDetectionRuleRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  testDetectionRuleRequestBody: TestDetectionRuleRequestBody;
};

/** @internal */
export type TestDetectionRuleSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const TestDetectionRuleSecurityOption1$outboundSchema: z.ZodMiniType<
  TestDetectionRuleSecurityOption1$Outbound,
  TestDetectionRuleSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function testDetectionRuleSecurityOption1ToJSON(
  testDetectionRuleSecurityOption1: TestDetectionRuleSecurityOption1,
): string {
  return JSON.stringify(
    TestDetectionRuleSecurityOption1$outboundSchema.parse(
      testDetectionRuleSecurityOption1,
    ),
  );
}

/** @internal */
export type TestDetectionRuleSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const TestDetectionRuleSecurityOption2$outboundSchema: z.ZodMiniType<
  TestDetectionRuleSecurityOption2$Outbound,
  TestDetectionRuleSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function testDetectionRuleSecurityOption2ToJSON(
  testDetectionRuleSecurityOption2: TestDetectionRuleSecurityOption2,
): string {
  return JSON.stringify(
    TestDetectionRuleSecurityOption2$outboundSchema.parse(
      testDetectionRuleSecurityOption2,
    ),
  );
}

/** @internal */
export type TestDetectionRuleSecurity$Outbound = {
  Option1?: TestDetectionRuleSecurityOption1$Outbound | undefined;
  Option2?: TestDetectionRuleSecurityOption2$Outbound | undefined;
};

/** @internal */
export const TestDetectionRuleSecurity$outboundSchema: z.ZodMiniType<
  TestDetectionRuleSecurity$Outbound,
  TestDetectionRuleSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => TestDetectionRuleSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => TestDetectionRuleSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function testDetectionRuleSecurityToJSON(
  testDetectionRuleSecurity: TestDetectionRuleSecurity,
): string {
  return JSON.stringify(
    TestDetectionRuleSecurity$outboundSchema.parse(testDetectionRuleSecurity),
  );
}

/** @internal */
export type TestDetectionRuleRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  TestDetectionRuleRequestBody: TestDetectionRuleRequestBody$Outbound;
};

/** @internal */
export const TestDetectionRuleRequest$outboundSchema: z.ZodMiniType<
  TestDetectionRuleRequest$Outbound,
  TestDetectionRuleRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    testDetectionRuleRequestBody: TestDetectionRuleRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      testDetectionRuleRequestBody: "TestDetectionRuleRequestBody",
    });
  }),
);

export function testDetectionRuleRequestToJSON(
  testDetectionRuleRequest: TestDetectionRuleRequest,
): string {
  return JSON.stringify(
    TestDetectionRuleRequest$outboundSchema.parse(testDetectionRuleRequest),
  );
}
